import ReactDOM from 'react-dom';
import { useIframeContext } from '../../context/IframeContext';
import { useContext, useEffect, useState } from 'react';
import LayersContext from '../../context/LayersContext';

interface LayersModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const LayersModal: React.FC<LayersModalProps> = ({ isOpen, onClose }) => {
    const { isIframe } = useIframeContext();
    const { layers } = useContext(LayersContext);
    const [activeLayer, setActiveLayer] = useState<string | null>(null);

    // Hide main scrollbar when the metadata panel is open
    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className={`fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 transition-all duration-500 transform ${!isOpen ? 'translate-y-full' : 'translate-y-0'} ${!isIframe && 'max-w-full mx-auto'}`}>
            <div className={`bg-white p-6 w-full overflow-y-auto h-full relative transition-transform duration-500 transform ${!isOpen ? 'translate-y-full' : 'translate-y-0'}`}>
                <button
                    className="absolute top-3 right-5 text-gray-600 text-3xl font-bold hover:text-black"
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    &times;
                </button>
                {/* Layer Buttons */}
                <div className="flex flex-wrap items-center justify-center gap-3 mb-4">
                    {layers.map((layer) => (
                        <button
                            key={layer.layer_id}
                            className={`px-4 py-2 text-sm rounded-md ${
                                activeLayer === layer.layer_name
                                    ? 'bg-color-cai-dashboard text-white'
                                    : 'bg-white text-color-cai-dashboard border'
                            }`}
                            onClick={() => setActiveLayer(layer.layer_name)}
                        >
                            {layer.layer_name}
                        </button>
                    ))}
                </div>

                {/* Active Layer Content */}
                {activeLayer && (
                    <div className="mt-4 p-4 bg-color-cai-dashboard text-white rounded-md flex flex-col">
                        <p className="text-sm">
                            <strong>Id:</strong> {layers.find(layer => layer.layer_name === activeLayer)?.layer_id}
                        </p>
                        <p className="text-sm">
                            <strong>Name:</strong> {layers.find(layer => layer.layer_name === activeLayer)?.layer_name}
                        </p>
                        <p className="text-sm">
                            <strong>Description:</strong> {layers.find(layer => layer.layer_name === activeLayer)?.layer_description}
                        </p>
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
};

export default LayersModal;